<template>
  <div>
    <b-field
      :label="$t('compCarbonFormsTravelsSectionForm.travel-mode') + ' *'"
      :type="{ 'is-danger': errors.has(travelMeanRandName) }"
      :message="errors.first(travelMeanRandName)"
    >
      <b-select
        expanded
        :placeholder="
          $t('compCarbonFormsTravelsSectionForm.travel-mode') + ' *'
        "
        :icon="modeIcon"
        :icon-pack="modePack"
        :name="travelMeanRandName"
        @input="$emit('input', buffer)"
        v-validate="'required'"
        v-model="buffer.transportation"
      >
        <option
          :value="mode"
          v-for="(mode, index) in modesDeplacements"
          :key="index"
        >
          {{ $t(mode) }}
        </option>
      </b-select>
    </b-field>
    <b-field
      v-if="carpoolingVisible"
      :label="$t('compCarbonFormsTravelsSectionForm.carpooling')"
      :type="{ 'is-danger': errors.has(carpoolingRandName) }"
      :message="errors.first(carpoolingRandName)"
    >
      <b-input
        :name="carpoolingRandName"
        v-validate="'required|numeric|min_value:1'"
        @input="updateCarpooling"
        icon="users"
        type="number"
        v-model="buffer.carpooling"
      ></b-input>
    </b-field>
    <geonames-input
      :label="$t('compCarbonFormsTravelsSectionForm.departure-city')"
      :value="buffer.departureCity"
      @select="updateDeparture"
      :countryCode="buffer.departureCountry"
      :readonly="departureIsReadOnly"
    />
    <geonames-input
      :label="$t('compCarbonFormsTravelsSectionForm.destination-city')"
      :value="buffer.destinationCity"
      @select="updateDestination"
      :countryCode="buffer.destinationCountry"
      :readonly="destinationIsReadOnly"
    />
    <b-field :label="$t('compCarbonFormsTravelsSectionForm.label-round-trip')">
      <b-switch v-model="buffer.isRoundTrip" @input="$emit('input', buffer)">
        {{ $t('compCarbonFormsTravelsSectionForm.round-trip') }}
      </b-switch>
    </b-field>
  </div>
</template>

<script>
import Travel from '@/models/carbon/Travel.js'
import TravelSection from '@/models/carbon/TravelSection.js'

export default {
  name: 'SectionForm',
  inject: ['$validator'],
  props: {
    value: {
      type: Object,
      default: function () {
        return {}
      }
    },
    departureIsReadOnly: {
      type: Boolean,
      default: false
    },
    destinationIsReadOnly: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'geonames-input': () => import('@/components/GeonamesInput.vue')
  },
  data () {
    return {
      buffer: TravelSection.createFromObj(this.value),
      modesDeplacements: Travel.transportations,
      carpoolingVisible: false,
      sections: 1,
      activeSection: 0,
      prevDepartureCity: this.value.departureCity,
      prevDestinationCity: this.value.destinationCity
    }
  },
  computed: {
    travelMeanRandName: function () {
      return 'travel-mean' + Math.floor(Math.random() * 1000000)
    },
    carpoolingRandName: function () {
      return 'carpooling' + Math.floor(Math.random() * 1000000)
    },
    modeIcon: function () {
      return Travel.getIcon(this.buffer.transportation)
    },
    modePack: function () {
      return Travel.getIconPack(this.buffer.transportation)
    }
  },
  methods: {
    updateDeparture: function (option) {
      this.buffer.departureCountry = option.countryCode
      this.buffer.departureCity = option.name
      this.buffer.departureCityLat = parseFloat(option.lat)
      this.buffer.departureCityLng = parseFloat(option.lng)
      this.$emit('input', this.buffer)
      this.$emit('update-departure', this.buffer, this.prevDepartureCity)
      this.prevDepartureCity = this.buffer.departureCity
    },
    updateDestination: function (option) {
      this.buffer.destinationCountry = option.countryCode
      this.buffer.destinationCity = option.name
      this.buffer.destinationCityLat = parseFloat(option.lat)
      this.buffer.destinationCityLng = parseFloat(option.lng)
      this.$emit('input', this.buffer)
      this.$emit('update-destination', this.buffer, this.prevDestinationCity)
      this.prevDestinationCity = this.buffer.destinationCity
    },
    updateCarpooling: function () {
      this.$emit('input', this.buffer)
    }
  },
  watch: {
    value: {
      handler () {
        this.buffer = TravelSection.createFromObj(this.value)
        this.prevDepartureCity = this.buffer.departureCity
        this.prevDestinationCity = this.buffer.destinationCity
      },
      deep: true
    },
    'buffer.transportation': function () {
      if (
        [Travel.MODE_CAB, Travel.MODE_CAR].includes(this.buffer.transportation)
      ) {
        this.carpoolingVisible = true
      } else {
        this.carpoolingVisible = false
      }
    }
  },
  mounted () {
    if (
      [Travel.MODE_CAB, Travel.MODE_CAR].includes(this.buffer.transportation)
    ) {
      this.carpoolingVisible = true
    }
  }
}
</script>
